import * as actionType from "../actionTypes";
import axios from "axios";
import apiConstants from "../../constans/apiConstants";
import {toaster} from "../../utils/utils";

export const addProductAction = (productName, productCode, productType) => async (dispatch) => {
    dispatch({type: actionType.LOADER_TRUE});
    await axios.post(
        `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/add/product`,
        {productName, productCode, productType},
        {
            headers: {
                "Content-Type": "application/json",
                authorization: localStorage.getItem("token"),
            },
        })

        .then(res => {
            dispatch({type: actionType.LOADER_FALSE});
            if (res.data) {
                dispatch({
                    type: actionType.PRODUCT_LIST,
                    productList: res.data.body
                })
                toaster("success", res.data.message);
            } else {
                toaster("error", res.data.message);
            }
        })
        .catch(err => {
            dispatch({type: actionType.LOADER_FALSE});
            dispatch({
                type: actionType.PRODUCT_LIST,
                productList: []
            })
            toaster("error", err.data && err.data.message);
        })
};

export const getPlanTypeList = () => {
    return dispatch => {
        dispatch({type: actionType.LOADER_TRUE});
        axios.get(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/product/type/findAll`, {
            headers: {
                "Content-Type": "application/json",
                authorization: localStorage.getItem("token"),
            }
        }).then((res) => {
            dispatch({type: actionType.LOADER_FALSE})
            if (res.data) {
                dispatch({
                    type: actionType.PRODUCT_TYPE_LIST,
                    productTypeList: res.data
                })
                toaster("success", "Success");
            } else {
                toaster("error", "Failed");
            }
        }).catch(() => {
            dispatch({type: actionType.LOADER_FALSE});
            dispatch({
                type: actionType.PRODUCT_TYPE_LIST,
                productTypeList: []
            })
        })
    }
}

export const getProductList = () => {
    return dispatch => {
        dispatch({type: actionType.LOADER_TRUE});
        axios.get(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/product/findAll`, {
            headers: {
                "Content-Type": "application/json",
                authorization: localStorage.getItem("token"),
            }
        })

            .then((res) => {
                dispatch({type: actionType.LOADER_FALSE});
                if (res.data) {
                    dispatch({
                        type: actionType.PRODUCT_LIST,
                        productList: res.data
                    })
                    // toaster("success", "Success");
                } else {
                    toaster("error", "Failed");
                }
            }).catch(() => {
            dispatch({type: actionType.LOADER_FALSE});
            dispatch({
                type: actionType.PRODUCT_LIST,
                productList: []
            })
        })
    }
}

export const updateProductStatus = (productId, status) => async (dispatch) => {
    dispatch({type: actionType.LOADER_TRUE});
    await axios.put(
        `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/toggle/product/status?productId=${productId}&status=${status}`,
        {},
        {
            headers: {
                "Content-Type": "application/json",
                authorization: localStorage.getItem("token"),
            },
        })
        .then(res => {
            dispatch({type: actionType.LOADER_FALSE});
            if (res.data) {
                dispatch({
                    type: actionType.PRODUCT_LIST,
                    productList: res.data.body
                })
                toaster("success", res.data.message);
            } else {
                toaster("error", res.data.message);
            }
        })
        .catch(err => {
            dispatch({type: actionType.LOADER_FALSE});
            dispatch({
                type: actionType.PRODUCT_LIST,
                productList: []
            })
            toaster("error", err.data && err.data.message);
        })
};
export const updateissuanceType = (productId, status) => async (dispatch) => {
    let newID = productId.trim();
    dispatch({type: actionType.LOADER_TRUE});
    await axios.put(
        `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/toggle/product/issuanceType?productId=${newID}&issuanceType=${status}`,
        {},
        {
            headers: {
                "Content-Type": "application/json",
                authorization: localStorage.getItem("token"),
            },
        })
        .then(res => {
            dispatch({type: actionType.LOADER_FALSE});
            if (res.data) {
                dispatch({
                    type: actionType.PRODUCT_LIST,
                    productList: res.data.body
                })
                toaster("success", res.data.message);
            } else {
                toaster("error", res.data.message);
            }
        })
        .catch(err => {
            dispatch({type: actionType.LOADER_FALSE});
            dispatch({
                type: actionType.PRODUCT_LIST,
                productList: []
            })
            toaster("error", err.data && err.data.message);
        })
};


export const uinSaveHandlerAction = (productId, uin) => async (dispatch) => {
    const newID = String(productId).trim();
    dispatch({type: actionType.LOADER_TRUE});
    try {
        const res = await axios.put(
            `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/update/product/version?productId=${newID}&productVersion=${uin}`,
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: localStorage.getItem("token"),
                },
            });
        dispatch({type: actionType.LOADER_FALSE});
        if (res.data) {
            dispatch({
                type: actionType.PRODUCT_LIST,
                productList: res.data.body
            });
            toaster("success", res.data.message);
            return res;
        }
        toaster("error", res.data.message);
        throw new Error(res.data.message);
    } catch (err) {
        dispatch({type: actionType.LOADER_FALSE});
        dispatch({
            type: actionType.PRODUCT_LIST,
            productList: []
        });
        toaster("error", err.data && err.data.message);
        throw err;
    }
};